// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import type { Props, State } from '../../../types.tsx';
import type { UpdateValueDecorationProps } from './types.tsx';
import { updateInternal } from './utils.tsx';

export const updateValueDecoration =
	(updateProps: UpdateValueDecorationProps) =>
	(
		{ getState, setState }: StoreActionApi<State>,
		{ fieldRemote, onDecorationUpdateFailed, createAnalyticsEvent }: Props,
	) => {
		updateInternal(
			updateProps,
			fieldRemote,
			getState,
			setState,
			onDecorationUpdateFailed,
			createAnalyticsEvent,
		);
	};
